import { redirect } from "react-router-dom";
import { hasValidAddress, hasValidRoofArea, hasValidRoofObstacle, skipRoof } from "./routeValidator";
import { parseHashQueryParams } from 'services/routingHelper'

function timeout(delay) {
  return new Promise( res => setTimeout(res, delay) );
}

export async function guardedAddressSelection() {
  await timeout(300);
  return true;
}

export async function guardedRoofTypeLoader() {
  if (!hasValidAddress()) {
    return redirect("/");
  }
  await timeout(300);
  return true;
}

export async function guardedRoofAreaLoader() {
  if (!hasValidAddress()) {
    return redirect("/");
  }
  await timeout(300);
  return true;
}

export async function guardedObstaclesLoader() {
  if (!hasValidAddress() || !hasValidRoofArea()) {
    return redirect("/");
  }
  await timeout(300);
  return true;
}

export async function guardedEnergyConsumptionLoader() {
  // if (!hasValidAddress()) {
  //   return redirect("/");
  // }

  if (!hasValidAddress() || !hasValidRoofArea() || !hasValidRoofObstacle()) {
  // if (!skipRoof() && (!hasValidRoofArea() || !hasValidRoofObstacle())) {
    return redirect("/");
  }

  await timeout(300);
  return true;
}

export async function guardedEnergyCostLoader() {
  if (!hasValidAddress() || !hasValidRoofArea() || !hasValidRoofObstacle()) {
    return redirect("/");
  }
  await timeout(300);
  return true;
}

export async function guardedElectricalBoxLoader() {
  if (!hasValidAddress() || !hasValidRoofArea() || !hasValidRoofObstacle()) {
    return redirect("/");
  }
  await timeout(300);
  return true;
}

export async function guardedContactLoader() {
  if (!hasValidAddress() || !hasValidRoofArea() || !hasValidRoofObstacle()) {
    return redirect("/");
  }
  await timeout(300);
  return true;
}

export async function guardedQRCodeEvaluationLoader() {
  const query = parseHashQueryParams();
  if (!query.id) {
    return redirect("/");
  }
  await timeout(300);
  return true;
}
